import { useEffect, useState } from "react";
import { usePaginationSync } from "../../../../hooks/usePaginationSync";
import { useGetUnknownAssets } from "../../../../helpers/queries/scans/useGetInventory";
import empty from "../../../../assets/images/empty_assets.png";
import { Spinner } from "../../../../components/Spinner";
import { PaginationComponent } from "../../../../components/Pagination";
import DataTable from "../../../../components/DataTable";

const Unknown = () => {
  const [lastPage, setLastPage] = useState(1);
  const { currentPage, updatePage } = usePaginationSync(lastPage);
  const { isLoading, isSuccess, isError, data } =
    useGetUnknownAssets(currentPage);
  useEffect(() => {
    setLastPage(data?.pagination?.last_page);
  }, [data]);

  const columns = [
    {
      accessorKey: "name",
      header: () => <span className="block">Hostname</span>,
      cell: ({ row }) => <span className="block">{row.original.name}</span>,
    },
    {
      accessorKey: "mac_address",
      header: () => <span className="block">Mac Address</span>,
      cell: ({ row }) => (
        <span className="block">{row.original.mac_address}</span>
      ),
    },
    {
      accessorKey: "ip_address",
      header: () => <span className="block">IP Address</span>,
      cell: ({ row }) => (
        <span className="block">{row.original.ip_address}</span>
      ),
    },
  ];

  return (
    <div>
      {isLoading && !isSuccess && (
        <div className="h-[55vh] w-full flex items-center justify-center">
          <Spinner />
        </div>
      )}

      {isError && !isLoading && (
        <div className="h-[45vh] w-full flex justify-center flex-col items-center">
          <p className="font-semibold text-xl text-center">
            There was an error getting the data
          </p>
          <p className="text-center">{data?.message ?? ""}</p>
        </div>
      )}

      {!isLoading && isSuccess && data?.data?.length > 0 && (
        <div className="lg:p-10 md:p-5 p-4 bg-white h-[100%]">
          <DataTable columns={columns} data={data?.data} />

          <PaginationComponent
            lastPage={data?.pagination?.last_page}
            currentPage={currentPage}
            handlePageChange={updatePage}
          />
        </div>
      )}

      {data?.data?.length === 0 && !isLoading && isSuccess && (
        <div className="h-[45vh] mt-[6rem] w-full flex justify-center flex-col items-center text-center p-4">
          <img src={empty} alt="empty" />
          <p className=" font-semibold my-2 text-darkGrey">
            No unknown assets have been added yet
          </p>
          <p className="text-neutral600 text-sm max-w-[360px] mb-4">
            Start by adding your first asset. This can be domains or IP
            addresses you'd like to monitor for vulnerabilities.
          </p>
          {/* {role && role !== "Viewer" && data?.data?.data?.length === 0 && (
            <AddTargetModal />
          )} */}
        </div>
      )}
    </div>
  );
};

export default Unknown;
